import { TextColor, TextType } from './Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export type StyleProps = {
  textType?: TextType;
  textColor?: TextColor;
  fontWeight?: number;
};

const getFontSize = (textType?: TextType) => {
  switch (textType) {
    case 'smallText':
      return '12px';
    case 'hint':
      return '14px';
    case 'button':
    case 'text':
      return '16px';
    case 'title':
      return '18px';
    case 'large':
      return '26px';
  }
};

const getLineHeight = (textType?: TextType) => {
  switch (textType) {
    case 'smallText':
      return '14px';
    case 'hint':
      return '16px';
    case 'button':
    case 'text':
      return '18px';
    case 'title':
      return '22px';
  }
};

const getColor = (textColor?: TextColor) => {
  switch (textColor) {
    case 'grey':
      return 'rgba(26,17,24,.6)';
    case 'black':
      return 'rgb(26,17,24)';
    case 'white':
      return 'rgb(255,255,255)';
  }
};

export const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    root: (props) => ({
      fontSize: getFontSize(props.textType),
      lineHeight: getLineHeight(props.textType),
      color: getColor(props.textColor),
      fontWeight: props.fontWeight,
    }),
  })
);
